import Channel from '@/shared/classes/channels/channel'
import { ExtendedEpgElement } from '@/types/epg/Epg'

const getChannelPrograms = (
    epgData: ExtendedEpgElement[],
    channel: Channel
) => {
    const selectedChannel = epgData?.find(
        (element) => element.channelId === channel.id
    )

    const programs = selectedChannel?.programs.length
        ? selectedChannel.programs
        : []
    return programs
}

export default getChannelPrograms
